import Breadcrumbs from '@/components/Breadcrumbs'
import { assetUrl } from '@/utils/asset-url'
import Button from '@/components/Button'
import Portal from '@/components/Portal'
import usePage from '@/hooks/use-page'
import { useNavigate, useLocation, useParams } from '@/lib/router-dom'
import { getUseCaseId } from "@/utils/use-case-storage"
import { useEffect, useMemo, useState } from 'react'
import { Box } from '@dextech-ai/dex-design-system'

const Page = () => {

	/*=================================================
		General
	/================================================*/

	const { useCaseId } = useParams()
	const useCase = useMemo(() => getUseCaseId(useCaseId), [useCaseId]);

	const [pageTitle, setPageTitle] = useState('Request Sent')
	const [subPageTitle, setSubPageTitle] = useState(useCase.name)

	const { breadcrumbsItems } = usePage({ title: pageTitle, breadcrumbs: ['Explore Use Cases', subPageTitle, pageTitle] })

	const { currentState, currentPath } = useLocation()
	const { goTo } = useNavigate()

	const [name, setName] = useState('');

	/*=================================================
		API
	/================================================*/

	useEffect(() => {
		setName(currentState?.participant.organization.name);
	}, [currentState])

	/*=================================================
		Navigate
	/================================================*/
	function backToDashboard() {
		const location = currentPath.split('/').slice(0,-2).join('/');
		goTo(`${location}`)
	}

	return(
		<>
			<Box display="flex" align="center" direction="column" py={25}>
				<div className="layout-feedback__header">{pageTitle}</div>
				<div className="layout-feedback__subheader layout-feedback__subheader--center">
					You have requested for the data elements from {name}.<br/>
					We'll notify you when it is approved.
				</div>
				<div className="layout-feedback__content">

					<img src={assetUrl("/img/requestsuccess.png")} />
				</div>
				<div className="layout-feedback__footer">
					<Button sizing='Medium' text='Back to Dashboard' round submit={() => backToDashboard()} />
				</div>
			</Box>

		</>
	)
}

export default Page
